import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function NavBar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  return (
    <>
      <nav className="navbar  bg-white">
        <div className="nav-container "> 
          <NavLink exact to="/" className="nav-logo" aria-disabled>
            AaoCodeKare 
            {/* <i className="fa fa-code"></i> */}
          </NavLink>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink  exact to="/"  activeClassName="active"  className="nav-links"  onClick={handleClick}  >    Home  </NavLink>
            </li>
            <li className="nav-item">
              <NavLink exact to="/about" id="#milan" activeClassName="active"  className="nav-links"  onClick={handleClick}> About    </NavLink>
            </li>
            <li className="nav-item">
              <NavLink  exact   to="/Contact"  activeClassName="active"  className="nav-links"  onClick={handleClick}>Contact</NavLink>
            </li> 
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
          </div>
        </div>
      </nav>
    </>
  );
}

export default NavBar;